/**
 * All user types
 * @type {Object}
 */
export const UserTypes = Object.freeze({
  STUDENT: 'STUDENT',
  LOGGED_OUT_USER: 'LOGGED_OUT_USER',
})

// NOTE: You will need to do a deep clone on this to use it for your form
export const passwordRequirements = Object.freeze({
  upperCase: {
    text: 'One uppercase character (A-Z)',
    rule: (value) => /\p{Lu}/u.test(value),
    valid: false,
  },
  lowerCase: {
    text: 'One lowercase character (a-z)',
    rule: (value) => /\p{Ll}/u.test(value),
    valid: false,
  },
  number: {
    text: 'One number (0-9)',
    rule: (value) => /\d/.test(value),
    valid: false,
  },
  symbol: {
    text: 'One symbol (e.g. $, !, #, &)',
    rule: (value) => /[^0-9a-zA-Z]/.test(value),
    valid: false,
  },
  minChars: {
    text: 'More than 8 characters',
    rule: (value) => value.length > 8,
    valid: false,
  },
})
